"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getYoutubeCode = exports.createObjectKey = exports.trimSlashes = exports.slugify = exports.generateRandomString = void 0;
function generateRandomString(size = 15) {
    const collection = 'qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM1234567890-_';
    let result = '';
    for (let i = 0; i < size; i++) {
        const index = Math.floor(Math.random() * collection.length);
        result += collection[index];
    }
    return result;
}
exports.generateRandomString = generateRandomString;
function slugify(text) {
    return text
        .toString()
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^\w\-.]+/g, '')
        .replace(/--+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');
}
exports.slugify = slugify;
/**
 * Remove slashes at the beginning and end of the string
 */
function trimSlashes(text) {
    return text.replace(/^\/|\/$/g, '');
}
exports.trimSlashes = trimSlashes;
function createObjectKey(files, bucket, objectKey) {
    const randomId = generateRandomString(15);
    const path = trimSlashes(objectKey);
    const updatedFiles = Object.assign({}, files);
    Object.keys(updatedFiles).forEach((fileId) => {
        updatedFiles[fileId].meta.name = encodeURI(path + `/${randomId}/` + slugify(updatedFiles[fileId].name));
    });
    return updatedFiles;
}
exports.createObjectKey = createObjectKey;
function getYoutubeCode(url) {
    const youtubeCodeRegex = /(youtu\.be\/|youtube\.com\/(watch\?(.*&)?v=|(embed|v)\/))([^?&"'>]+)/;
    let match = url.match(youtubeCodeRegex);
    let code = match && match.length > 4 && match[5];
    if (!code) {
        match = url.trim().match(/^[a-zA-Z0-9_-]{11}$/);
        code = match && match[0];
    }
    return code || undefined;
}
exports.getYoutubeCode = getYoutubeCode;
//# sourceMappingURL=uploader.utils.js.map